import React from "react";
import { string } from "prop-types";
import { WithContext as ReactTags } from "react-tag-input";
import Button from "pages/_components/Button";
import { useTags } from "pages/echeck/hooks/useTags";

const ReactTagWithoutInput = ({ optionEcheq }) => {
    const { tags, handleDelete, handleCleanFilters } = useTags(optionEcheq);

    if (!tags.length) {
        return null;
    }

    return (
        <>
            <ReactTags
                autofocus={false}
                tags={tags}
                handleDelete={handleDelete}
                allowDragDrop={false}
                placeholder=""
                inputProps={{
                    disabled: true,
                    autocomplete: "off",
                }}
                classNames={{
                    tags: "tagsClass",
                    selected: "selectedClass",
                    tag: "tagClass",
                    remove: "removeClass",
                }}
            />

            <Button
                image="images/figma/icon/clear-filter.svg"
                onClick={handleCleanFilters}
                label="echecks.clean.filters"
                className="btn btn-link clear-filters"
                block={false}
                icon=""
            />
        </>
    );
};

ReactTagWithoutInput.propTypes = {
    optionEcheq: string.isRequired,
};

export default ReactTagWithoutInput;
